/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import {
  color,
  space,
  border,
  layout,
  flexbox,
  BorderProps,
  SpaceProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
} from 'styled-system';
import { Image as PrimitiveImage } from '@staffino/primitives';
import type {} from 'csstype';
import styled from './styled';

type ImageProps = SpaceProps &
  ColorProps &
  LayoutProps &
  FlexboxProps &
  BorderProps;

const Image = styled(PrimitiveImage)<ImageProps>(
  space,
  color,
  layout,
  flexbox,
  border,
);
export default Image;
